/* eslint-disable */
export const inOutQuintic = (t, b, c, d) => {
  var ts = (t/=d)*t,
  tc = ts*t;
  return b+c*(6*tc*ts + -15*ts*ts + 10*tc);
};
/* eslint-enable */
